import React from "react";
import { motion } from "framer-motion";
import styles from "./PageHero.module.css";

const fadeUp = {
    hidden: { opacity: 0, y: 12 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] },
    },
};

/**
 * PageHero — nagłówek podstrony (hero). API 1:1 z mPracownika.
 *
 * WYGLĄD: kanoniczny wariant z docs/DESIGN-SYSTEM-PODSTRON.md — ciemny slate
 * (#0f172a → #1e293b → #334155) + warstwy .heroGlow i .heroPattern, czyli dokładnie to,
 * co mają już wszystkie podstrony Biura Przepustek (PassesPage, CardsPage, GuardScanPage…).
 * (mPracownikowy PageHero używał indygo #1e1b4b, ale nie był tam nigdzie importowany —
 * realnym wzorcem są lokalne .hero w modułach stron. Trzymamy się wzorca aplikacji.)
 *
 * @param {string}  badge     – etykieta kategorii (np. "Przepustki", "Administracja")
 * @param {string}  title     – tytuł strony (<h1>)
 * @param {string}  subtitle  – krótki opis
 * @param {boolean} compact   – mniejszy wariant "narzędziowy"
 * @param {string}  gradient  – opcjonalne własne tło (CSS), nadpisuje slate
 * @param {React.ReactNode} children – prawa strona hero (statystyki, akcje)
 */
const PageHero = ({ badge, title, subtitle, compact = false, gradient, children }) => {
    return (
        <motion.div
            className={`${styles.hero} ${compact ? styles.heroCompact : ""}`}
            style={gradient ? { background: gradient } : undefined}
            initial="hidden"
            animate="visible"
            variants={fadeUp}
        >
            <div className={styles.heroGlow} />
            <div className={styles.heroPattern} />
            <div className={styles.heroContent}>
                <div className={styles.heroLeft}>
                    {badge && (
                        <span className={styles.heroBadge}>
                            <span className={styles.heroBadgeDot} />
                            {badge}
                        </span>
                    )}
                    <h1 className={compact ? styles.heroTitleCompact : styles.heroTitle}>{title}</h1>
                    {subtitle && (
                        <p className={compact ? styles.heroSubtitleCompact : styles.heroSubtitle}>
                            {subtitle}
                        </p>
                    )}
                </div>
                {children && <div className={styles.heroRight}>{children}</div>}
            </div>
        </motion.div>
    );
};

export default PageHero;
